import React, { useState, useEffect } from "react";
import axios from "axios";
import io from "socket.io-client";
import Select from "react-select";
import { toast, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useAlert } from "react-alert";
import SearchField from "react-search-field";
import { Brightness1, SwapHoriz } from "@material-ui/icons";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import PulseLoader from "react-spinners/PulseLoader";
import { makeStyles } from "@material-ui/core/styles";

import TabBar from "../components/tab-bar";

const useStyles = makeStyles(() => ({
  root: {
    color: "aliceblue",
  },
}));

const Menuchain = () => {
  toast.configure();
  const classes = useStyles();
  const alert = useAlert();
  const [token, setToken] = useState("");
  const [resInfo] = useState(JSON.parse(localStorage.getItem("login")) || []);
  const [sambaMenu, setSambaMenu] = useState([]);
  const [resId, setResId] = useState("");
  const [searchItem, setSearchItem] = useState("");
  const [alignmentItem, setAlignmentItem] = useState("OK");
  const [menu, setMenu] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState([]);
  const [portion, setPortion] = useState([]);
  const [portionMatchInfo, setPortionMatchInfo] = useState([]);
  const [yeniDeneme, setYeniDeneme] = useState([]);
  const [success, setSuccess] = useState(false);
  const [matchedMenu, setMatchedMenu] = useState([]);
  const [portionName, setPortionName] = useState("");
  const [menuIStatus, setMenuIStatus] = useState(0);

  useEffect(() => {
    getToken();
    getState();
  }, []);

  useEffect(() => {
    if (resId !== "" && token !== "") {
      getResMenu();
    }
  }, [resId, token]);

  const getToken = async () => {
    await axios
      .post("https://getirs2.sambapos.com/auth", {
        appsecretKey: resInfo.appsecretKey,
        restaurantsecretKey: resInfo.restaurantsecretKey,
      })
      .then((resp) => {
        setResId(resp.data.restaurantId);
        setToken(resp.data.token);
      })
      .catch((err) => {
        alert.show(err.response.data.error);
      });
  };

  const getState = async () => {
    await axios
      .post("https://getirs2.sambapos.com/customers/state", {
        emailState: resInfo.email,
      })
      .then((resp) => {
        setPortionName(resp.data.portion);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getMatchedMenu = async () => {
    await axios
      .get(`https://getirs2.sambapos.com/matchMenu/${resInfo.licenseEmail}`)
      .then((res) => {
        setMatchedMenu(res.data);
      });
  };

  const fetchMenu = async () => {
    toast.success(` 👍 Senkronize Ediliyor`, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      transition: Flip,
    });
    const socketSambaMenu = io("https://getirs.sambapos.com");
    socketSambaMenu.emit("items", resInfo.licenseEmail);
    socketSambaMenu.on("items_res", async (data) => {
      const sambaMenuData = JSON.parse(data);
      socketSambaMenu.close();

      await axios
        .post("https://getirs2.sambapos.com/sambaMenu/destroy", {
          l_email: sambaMenuData.LicenseEmail,
        })
        .then(async () => {
          await axios.post("https://getirs2.sambapos.com/sambaMenu", {
            sambaMenuItem: sambaMenuData.Items,
            l_email: sambaMenuData.LicenseEmail,
          });
        });
    });

    await axios
      .post("https://getirs2.sambapos.com/restaurants/destroyResMenu", {
        resId,
      })
      .then(async () => {
        await axios
          .post(
            "https://getirs2.sambapos.com/restaurants/menu",
            { resId },
            {
              headers: {
                token: token,
              },
            }
          )
          .then(async (resp) => {
            await axios
              .post("https://getirs2.sambapos.com/v1/getResMenu", {
                resId,
                l_email: resInfo.licenseEmail,
              })
              .then((resp) => {
                matchMenu(resp.data.data, sambaMenu);
                getMatchedMenu();
                setSuccess(false);
                toast.success(` 👍 Senkronize Edildi`, {
                  position: "top-center",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  transition: Flip,
                });
              });
          });
      });

    getResMenu();
    socketSambaMenu.close();
  };

  const getResMenu = async () => {
    await axios
      .post("https://getirs2.sambapos.com/v1/getResMenu", {
        resId,
        l_email: resInfo.licenseEmail,
      })
      .then((resp) => {
        setMenu(resp.data.data);
        setSambaMenu(resp.data.sambaData);
        getMatchedMenu();
        setSuccess(true);
      });
  };

  const newMatch = (productId, e) => {
    let count = 0;
    setYeniDeneme({
      productId,
      value: e.target,
    });

    for (let i = 0; i < sambaMenu.length; i++) {
      if (
        sambaMenu[i].ItemName.replace(/ +/g, "") === e.target.replace(/ +/g, "")
      ) {
        count = count + 1;
        let selectedItem = {
          sambaId: sambaMenu[i].ItemId,
          getirId: productId,
          sambaName: sambaMenu[i].ItemName,
          sambaPortionId: sambaMenu[i].ItemPortions,
        };

        if (selectedMenu.length === 0) {
          selectedMenu.push(selectedItem);
          setSelectedMenu(selectedMenu);
        } else {
          for (let i = 0; i < selectedMenu.length; i++) {
            if (selectedMenu[i].getirId.includes(selectedItem.getirId)) {
              return (selectedMenu[i] = selectedItem);
            }
          }
          if (selectedMenu.includes(selectedItem) === false) {
            selectedMenu.push(selectedItem);
            setSelectedMenu(selectedMenu);
          }
        }
      }
    }
    if (count === 0) {
      let selectedItem = {
        sambaId: 0,
        getirId: productId,
        sambaName: 0,
        sambaPortionId: [],
      };
      for (let i = 0; i < selectedMenu.length; i++) {
        if (selectedMenu[i].getirId.includes(selectedItem.getirId)) {
          return (selectedMenu[i] = selectedItem);
        }
      }
      if (selectedMenu.includes(selectedItem) === false) {
        selectedMenu.push(selectedItem);
        setSelectedMenu(selectedMenu);
      }
    }
  };

  const porsionMatch = (portionName, e, productId) => {
    let portionInfo = {
      productId,
      portionName,
      sambaPortionName: e.target.value,
    };
    if (portion.length === 0) {
      portion.push(portionInfo);
      setPortionMatchInfo(portion);
    } else {
      for (let i = 0; i < portion.length; i++) {
        if (portion[i].portionName.includes(portionInfo.portionName)) {
          setPortion([]);
          portion[i] = portionInfo;
          setPortionMatchInfo(portion);
        }
      }
      if (portion.includes(portionInfo) === false) {
        portion.push(portionInfo);
        setPortionMatchInfo(portion);
      }
    }
  };

  const setItems = async () => {
    let count = 0;
    let matchMenuInfo = [];
    let kayit = true;
    if (selectedMenu.length === 0 && portionMatchInfo !== 0) {
      portionMatchInfo.map((portionMatchedItem) => {
        let matchInfo = {
          getirId: portionMatchedItem.productId,
          sambaId: 0,
          sambaName: "",
          sambaPortionId: portionMatchInfo.map((portion) => {
            let sambaPortionItem = {
              getirPorsiyon: portion.portionName,
              sambaPorsiyon: portion.sambaPortionName,
            };
            return sambaPortionItem;
          }),
        };
        matchMenuInfo.push(matchInfo);
      });
    }

    menu.map((options) => {
      selectedMenu.map((selectedMenuItem) => {
        if (
          selectedMenuItem.sambaId !== 0 &&
          selectedMenuItem.sambaName !== 0
        ) {
          if (options.product_id === selectedMenuItem.getirId) {
            if (options.options.length !== 0) {
              for (let x = 0; x < options.options.length; x++) {
                if (options.options[x].name.tr === portionName) {
                  count = count + 1;
                }
              }
              if (count !== 0) {
                if (portionMatchInfo.length !== 0) {
                  let matchInfo = {
                    getirId: selectedMenuItem.getirId,
                    sambaId: selectedMenuItem.sambaId,
                    sambaName: selectedMenuItem.sambaName,
                    sambaPortionId: portionMatchInfo.map((portion) => {
                      if (portion.productId === selectedMenuItem.getirId) {
                        let sambaPortionItem = {
                          getirPorsiyon: portion.portionName,
                          sambaPorsiyon: portion.sambaPortionName,
                        };
                        return sambaPortionItem;
                      }
                    }),
                  };
                  matchMenuInfo.push(matchInfo);
                } else {
                  kayit = false;
                  setSelectedMenu([]);
                  alert.show("Porsiyon Boş olamaz");
                }
              } else {
                let matchInfo = {
                  getirId: selectedMenuItem.getirId,
                  sambaId: selectedMenuItem.sambaId,
                  sambaName: selectedMenuItem.sambaName,
                  sambaPortionId: {
                    getirPorsiyon: "",
                    sambaPorsiyon: "",
                  },
                };
                matchMenuInfo.push(matchInfo);
              }
            } else {
              let matchInfo = {
                getirId: selectedMenuItem.getirId,
                sambaId: selectedMenuItem.sambaId,
                sambaName: selectedMenuItem.sambaName,
                sambaPortionId: {
                  getirPorsiyon: "",
                  sambaPorsiyon: "",
                },
              };
              matchMenuInfo.push(matchInfo);
            }
          }
        } else {
          let matchInfo = {
            getirId: selectedMenuItem.getirId,
            sambaId: 0,
            sambaName: 0,
            sambaPortionId: {
              getirPorsiyon: "",
              sambaPorsiyon: "",
            },
          };
          matchMenuInfo.push(matchInfo);
        }
      });
    });

    if (matchMenuInfo.length !== 0 && kayit === true) {
      try {
        await axios
          .post("https://getirs2.sambapos.com/matchMenu", {
            matchMenuInfo,
            l_email: resInfo.licenseEmail,
          })
          .then((resp) => {
            if (resp.data === "Güncelleme Kaydedildi") {
              alert.show(resp.data);
            } else if (resp.data === "Eşleştirme Silindi") {
              alert.show(resp.data);
            } else {
              alert.show("Kaydedildi");
            }
            setSelectedMenu([]);
            setPortionMatchInfo([]);
            // setPortion([]);
            getResMenu();
          });
      } catch (err) {
        console.log(err.message);
      }
    }
  };

  const matchMenu = async (menu, samba) => {
    let matchMenuInfo = [];

    for (let i = 0; i < menu.length; i++) {
      for (let x = 0; x < samba.length; x++) {
        if (menu[i].product_name.tr === samba[x].ItemName) {
          let matchInfo = {
            getirId: menu[i].product_id,
            sambaId: samba[x].ItemId,
            sambaName: samba[x].ItemName,
            sambaPortionId: {
              getirPorsiyon: "",
              sambaPorsiyon: "",
            },
          };
          matchMenuInfo.push(matchInfo);
        }
      }
    }

    await axios
      .post("https://getirs2.sambapos.com/matchMenu/autoMatch", {
        matchMenuInfo,
        l_email: resInfo.licenseEmail,
      })
      .then((resp) => {
        alert.show(resp.data);
        getResMenu();
      });
  };

  const searchMenu = (e) => {
    setSearchItem(e);
  };
  const alignmentItemFunc = (e) => {
    setAlignmentItem(e.target.value);
  };

  const getMenuItemStatus = async (productId, method) => {
    if (method === "set") {
      setMenuIStatus(50);
    } else {
      setMenuIStatus(0);
    }

    await axios
      .post(
        `https://getirs2.sambapos.com/v1/products/${productId}/status`,
        {},
        {
          headers: {
            token: token,
          },
        }
      )
      .then(async (resp) => {
        setMenuIStatus(resp.data.status);
      });
  };

  const setMenuItemStatus = async (productId, productStatus) => {
    let proStatus = 0;
    if (productStatus === 100) {
      proStatus = 200;
    } else {
      proStatus = 100;
    }
    await axios
      .put(
        `https://getirs2.sambapos.com/v1/products/${productId}/status`,
        { proStatus },
        {
          headers: {
            token: token,
          },
        }
      )
      .then(async (resp) => {
        if (resp.data.result === true) {
          await getMenuItemStatus(productId, "set");
        }
      })
      .catch((err) => {
        if (err.response.data.error === "Ürün durumu değişemiyor.") {
          setMenuIStatus(250);
        }
      });
  };

  return (
    <div
      className="tab-content card pt-5"
      id="myTabContentMD"
      style={{ textAlign: "-webkit-center", minHeight: 100 + "vh" }}
    >
      <TabBar
        item1={"Siparişler"}
        item1Route={"/order"}
        item2={"Ayarlar"}
        item2Route={"/settings"}
        pageName={"menuchain"}
      />
      {success === false ? (
        <div
          style={{
            display: "flex",
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <PulseLoader size={20} color={"#123abc"} />
        </div>
      ) : (
        <div style={{ margin: 20 }}>
          <div
            style={{
              marginTop: 30,
              textAlign: "end",
              marginLeft: 20,
              marginBottom: 20,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <button
              id="autochain"
              onClick={() => fetchMenu()}
              style={{
                float: "left",
                borderWidth: 0,
                backgroundColor: "#1976d2",
                width: 20 + "%",
                height: 30,

                borderRadius: 5,
                verticalAlign: "middle",
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span style={{ color: "#fff", fontWeight: 500 }}>
                Senkronize Et
              </span>
            </button>

            <div>
              <FormControl component="fieldset" style={{ textAlign: "center" }}>
                <FormLabel component="legend" style={{ fontWeight: "bold" }}>
                  Sıralama Türü
                </FormLabel>
                <RadioGroup
                  aria-label="gender"
                  name="gender1"
                  style={{ flexDirection: "row" }}
                  value={alignmentItem}
                  onChange={(event) => alignmentItemFunc(event)}
                >
                  <FormControlLabel
                    value={"OK"}
                    control={<Radio />}
                    label="Tüm Ürünler"
                  />
                  <FormControlLabel
                    value={"NOTOK"}
                    control={<Radio />}
                    label="Eşleştirilmiş Ürünler"
                  />
                  <FormControlLabel
                    value={"NOTOK2"}
                    control={<Radio />}
                    label="Eşleştirilmemiş Ürünler"
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div>
              <SearchField
                placeholder="Ürün arama"
                onChange={(e) => searchMenu(e)}
              />
            </div>
          </div>

          <table
            id="my-table"
            className="table table-striped table-bordered"
            cellSpacing="0"
            width="100%"
            style={{ backgroundColor: "oldlace" }}
          >
            <thead
              style={{
                backgroundColor: "gainsboro",
                textAlign: "center",
                WebkitTextStrokeWidth: "thin",
              }}
            >
              <tr>
                <th data-dynatable-column="name" data-dynatable-sorts="name">
                  Getir Ürün
                </th>
                <th>SambaPOS Ürün</th>
                <th>Ürün Durumu</th>
                <th>Porsiyon Durumu</th>
              </tr>
            </thead>

            <tbody style={{ textAlign: "center" }}>
              {menu
                .filter((data) => {
                  if (searchItem === "") {
                    return data;
                  } else if (
                    data.product_name.tr
                      .toLowerCase()
                      .includes(searchItem.toLowerCase())
                  ) {
                    return data;
                  }
                })
                .filter((data) => {
                  let items = matchedMenu.map((el) => el.getir_id);

                  if (alignmentItem === "OK") {
                    return data;
                  } else if (
                    alignmentItem === "NOTOK" &&
                    items.includes(data.product_id)
                  ) {
                    return data;
                  } else if (
                    alignmentItem === "NOTOK2" &&
                    !items.includes(data.product_id)
                  ) {
                    return data;
                  }
                })
                .map((menuchain, ind) => {
                  let matched = false;
                  let mainMatched = false;
                  let foodMatched = false;

                  return (
                    <tr key={ind}>
                      <td>
                        <div> {menuchain.product_name.tr}</div>
                        <div style={{ textAlignLast: "end" }}>
                          <OverlayTrigger
                            trigger={["click"]}
                            placement={"right"}
                            rootClose={true}
                            overlay={
                              <Tooltip
                                id={`tooltip-right`}
                                style={{
                                  width: 240,
                                }}
                              >
                                <div style={{ flex: 1, alignSelf: "center" }}>
                                  <Brightness1
                                    style={{
                                      width: 20,
                                      marginBottom: 5,
                                      color:
                                        menuIStatus === 100
                                          ? "#2adb27"
                                          : menuIStatus === 200
                                          ? "red"
                                          : menuIStatus === 50
                                          ? "blue"
                                          : menuIStatus === 250
                                          ? "tomato"
                                          : "yellow",
                                    }}
                                  />
                                  <span
                                    style={{
                                      color: "#fff",
                                      fontWeight: 500,
                                      marginLeft: 8,
                                      fontSize: 16,
                                      fontFamily: "cursive ",
                                    }}
                                  >
                                    {menuIStatus === 100
                                      ? "Aktif"
                                      : menuIStatus === 200
                                      ? "Pasif"
                                      : menuIStatus === 50
                                      ? "Güncelleniyor"
                                      : menuIStatus === 250
                                      ? "Durum Değiştirilemiyor"
                                      : "Kontrol Ediliyor"}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    textAlign: "end",
                                  }}
                                >
                                  <button
                                    style={{
                                      borderWidth: 0,
                                      background: "transparent",
                                    }}
                                    onClick={() =>
                                      setMenuItemStatus(
                                        menuchain.product_id,
                                        menuIStatus
                                      )
                                    }
                                  >
                                    <SwapHoriz
                                      classes={{
                                        root: classes.root,
                                      }}
                                    />
                                  </button>
                                </div>
                              </Tooltip>
                            }
                          >
                            <button
                              style={{
                                color: "#1948d2",
                                fontWeight: 500,
                                backgroundColor: "transparent",
                                borderWidth: 0,
                              }}
                              onClick={() =>
                                getMenuItemStatus(
                                  menuchain.product_id,
                                  "overlay"
                                )
                              }
                            >
                              Ürün Durumu
                            </button>
                          </OverlayTrigger>
                        </div>
                      </td>
                      <td style={{ width: 250 }}>
                        {matchedMenu.map((matchedItems, index) => {
                          if (matchedItems.getir_id === menuchain.product_id) {
                            if (
                              matchedItems.item_portion.getirPorsiyon === ""
                            ) {
                              mainMatched = true;
                            }
                            matched = true;
                            foodMatched = true;
                            for (let i = 0; i < sambaMenu.length; i++) {
                              if (
                                sambaMenu[i].ItemId === matchedItems.samba_id
                              ) {
                                return (
                                  <Select
                                    onChange={(e) =>
                                      newMatch(
                                        menuchain.product_id,
                                        {
                                          target: e !== null ? e.value : "",
                                        },
                                        matched
                                      )
                                    }
                                    options={sambaMenu.map((item) => ({
                                      label: item.ItemName,
                                      value: item.ItemName,
                                    }))}
                                    defaultValue={{
                                      label: sambaMenu[i].ItemName,
                                      value: sambaMenu[i].ItemName,
                                    }}
                                    isClearable={true}
                                  />
                                );
                              }
                            }
                          }
                        })}
                        {matched !== true && (
                          <Select
                            className="basic-single"
                            classNamePrefix="select"
                            isClearable={true}
                            onChange={(e) =>
                              newMatch(
                                menuchain.product_id,
                                { target: e !== null ? e.value : "" },
                                matched
                              )
                            }
                            options={sambaMenu.map((item) => ({
                              label: item.ItemName,
                              value: item.ItemName,
                            }))}
                            defaultValue={{
                              label: "Seçim",
                              value: "Seçim",
                            }}
                          />
                        )}
                      </td>
                      <td>
                        <div
                          style={{
                            backgroundColor: matched === true ? "green" : "red",
                            width: 100 + "%",
                            height: 38,
                            borderRadius: 5,
                            verticalAlign: "middle",
                            textAlign: "center",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <span style={{ color: "#fff", fontWeight: 500 }}>
                            {matched === true ? "Eşleştirildi" : "Eşleştir"}
                          </span>
                        </div>
                      </td>
                      <td>
                        {mainMatched === false &&
                        menuchain.options !== undefined ? (
                          menuchain.options.map((options, ind1) => {
                            if (options.name.tr === portionName) {
                              return (
                                <table
                                  key={ind1}
                                  style={{
                                    width: 100 + "%",
                                  }}
                                >
                                  <thead>
                                    <tr>
                                      <th>Getir</th>
                                      <th>SambaPOS</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  {options.options.map((optionName, ind) => {
                                    let porsionMatched = false;
                                    return (
                                      <tbody key={ind}>
                                        <tr>
                                          <td>
                                            <span style={{ lineHeight: 2.3 }}>
                                              {optionName.name.tr}
                                            </span>
                                          </td>
                                          <td>
                                            {matched !== true && (
                                              <select
                                                onChange={(e) =>
                                                  porsionMatch(
                                                    optionName.name.tr,
                                                    e,
                                                    menuchain.product_id
                                                  )
                                                }
                                                className="form-control"
                                                style={{
                                                  textAlignLast: "center",
                                                  height: 34,
                                                  marginBottom: 4,
                                                }}
                                              >
                                                <option>Tanımsız</option>

                                                {selectedMenu.map(
                                                  (selectedMItem) => {
                                                    if (
                                                      selectedMItem.getirId ===
                                                      menuchain.product_id
                                                    ) {
                                                      return selectedMItem.sambaPortionId.map(
                                                        (
                                                          selectedMenuItem2,
                                                          ind
                                                        ) => {
                                                          return (
                                                            <option key={ind}>
                                                              {
                                                                selectedMenuItem2.ItemPortionName
                                                              }
                                                            </option>
                                                          );
                                                        }
                                                      );
                                                    }
                                                  }
                                                )}
                                              </select>
                                            )}
                                            {matched === true && (
                                              <select
                                                onChange={(e) => (
                                                  newMatch(
                                                    menuchain.product_id,
                                                    { target: e.target.value }
                                                  ),
                                                  porsionMatch(
                                                    optionName.name.tr,
                                                    e,
                                                    menuchain.product_id
                                                  )
                                                )}
                                                className="form-control"
                                                style={{
                                                  textAlignLast: "center",
                                                  height: 34,
                                                  marginBottom: 4,
                                                }}
                                              >
                                                {matchedMenu.map(
                                                  (matchedItems) => {
                                                    if (
                                                      matchedItems.getir_id ===
                                                      menuchain.product_id
                                                    ) {
                                                      let a = "";
                                                      selectedMenu.map((w) => {
                                                        if (
                                                          w.getirId ===
                                                          menuchain.product_id
                                                        ) {
                                                          a = w.sambaName;
                                                        }
                                                      });

                                                      if (
                                                        a === "" ||
                                                        a ===
                                                          matchedItems.samba_name
                                                      ) {
                                                        return matchedItems.item_portion.map(
                                                          (portion, index) => {
                                                            if (portion) {
                                                              if (
                                                                options.options
                                                                  .length ===
                                                                matchedItems
                                                                  .item_portion
                                                                  .length
                                                              ) {
                                                                if (
                                                                  optionName
                                                                    .name.tr ===
                                                                  portion.getirPorsiyon
                                                                ) {
                                                                  porsionMatched = true;
                                                                  return (
                                                                    <React.Fragment>
                                                                      <option
                                                                        key={
                                                                          index
                                                                        }
                                                                      >
                                                                        {
                                                                          portion.sambaPorsiyon
                                                                        }
                                                                      </option>
                                                                      {sambaMenu.map(
                                                                        (
                                                                          sambaM
                                                                        ) => {
                                                                          if (
                                                                            sambaM.ItemName ===
                                                                            matchedItems.samba_name
                                                                          ) {
                                                                            return sambaM.ItemPortions.map(
                                                                              (
                                                                                sambaMe
                                                                              ) => {
                                                                                if (
                                                                                  sambaMe.ItemPortionName !==
                                                                                  portion.sambaPorsiyon
                                                                                ) {
                                                                                  return (
                                                                                    <option>
                                                                                      {
                                                                                        sambaMe.ItemPortionName
                                                                                      }
                                                                                    </option>
                                                                                  );
                                                                                }
                                                                              }
                                                                            );
                                                                          }
                                                                        }
                                                                      )}
                                                                    </React.Fragment>
                                                                  );
                                                                }
                                                              } else {
                                                                if (
                                                                  optionName
                                                                    .name.tr ===
                                                                  portion.getirPorsiyon
                                                                ) {
                                                                  porsionMatched = true;
                                                                  return (
                                                                    <React.Fragment>
                                                                      <option
                                                                        key={
                                                                          index
                                                                        }
                                                                      >
                                                                        {
                                                                          portion.sambaPorsiyon
                                                                        }
                                                                      </option>
                                                                      {sambaMenu.map(
                                                                        (
                                                                          sambaM
                                                                        ) => {
                                                                          if (
                                                                            sambaM.ItemName ===
                                                                            matchedItems.samba_name
                                                                          ) {
                                                                            return sambaM.ItemPortions.map(
                                                                              (
                                                                                sambaMe
                                                                              ) => {
                                                                                if (
                                                                                  sambaMe.ItemPortionName !==
                                                                                  portion.sambaPorsiyon
                                                                                ) {
                                                                                  return (
                                                                                    <option>
                                                                                      {
                                                                                        sambaMe.ItemPortionName
                                                                                      }
                                                                                    </option>
                                                                                  );
                                                                                }
                                                                              }
                                                                            );
                                                                          }
                                                                        }
                                                                      )}
                                                                    </React.Fragment>
                                                                  );
                                                                } else {
                                                                  return (
                                                                    <React.Fragment>
                                                                      <option>
                                                                        Tanımsız
                                                                      </option>
                                                                      {sambaMenu.map(
                                                                        (
                                                                          sambaM
                                                                        ) => {
                                                                          if (
                                                                            sambaM.ItemName ===
                                                                            matchedItems.samba_name
                                                                          ) {
                                                                            return sambaM.ItemPortions.map(
                                                                              (
                                                                                sambaMe
                                                                              ) => {
                                                                                return (
                                                                                  <option>
                                                                                    {
                                                                                      sambaMe.ItemPortionName
                                                                                    }
                                                                                  </option>
                                                                                );
                                                                              }
                                                                            );
                                                                          }
                                                                        }
                                                                      )}
                                                                    </React.Fragment>
                                                                  );
                                                                }
                                                              }
                                                            }
                                                          }
                                                        );
                                                      } else {
                                                        return (
                                                          <React.Fragment>
                                                            <option>
                                                              Tanımsız
                                                            </option>
                                                            {selectedMenu.map(
                                                              (
                                                                selectedMItem
                                                              ) => {
                                                                if (
                                                                  selectedMItem.getirId ===
                                                                  menuchain.product_id
                                                                ) {
                                                                  return selectedMItem.sambaPortionId.map(
                                                                    (
                                                                      selectedMenuItem2,
                                                                      ind
                                                                    ) => {
                                                                      return (
                                                                        <option
                                                                          key={
                                                                            ind
                                                                          }
                                                                        >
                                                                          {
                                                                            selectedMenuItem2.ItemPortionName
                                                                          }
                                                                        </option>
                                                                      );
                                                                    }
                                                                  );
                                                                }
                                                              }
                                                            )}
                                                          </React.Fragment>
                                                        );
                                                      }
                                                    }
                                                  }
                                                )}
                                              </select>
                                            )}
                                          </td>
                                          <td>
                                            <div
                                              style={{
                                                backgroundColor:
                                                  porsionMatched === true
                                                    ? "green"
                                                    : "red",
                                                width: 34,
                                                height: 34,
                                                borderRadius: 5,
                                                verticalAlign: "middle",
                                                textAlign: "center",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  color: "#fff",
                                                  fontWeight: 500,
                                                }}
                                              >
                                                <i
                                                  className={
                                                    porsionMatched === true
                                                      ? "fas fa-check-circle"
                                                      : "fas fa-exclamation-circle"
                                                  }
                                                ></i>
                                              </span>
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    );
                                  })}
                                </table>
                              );
                            }
                          })
                        ) : (
                          <div
                            style={{
                              backgroundColor:
                                foodMatched === true ? "green" : "red",
                              width: 100 + "%",
                              height: 38,
                              borderRadius: 5,
                              verticalAlign: "middle",
                              textAlign: "center",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <span style={{ color: "#fff", fontWeight: 500 }}>
                              {foodMatched === true
                                ? "Eşleştirildi"
                                : "Eşleştir"}
                            </span>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          <button
            onClick={() => setItems()}
            style={{
              width: 90 + "%",
              borderRadius: 20,
              marginBottom: 50,
            }}
            type="button"
            className="btn save-menu btn-primary btn-block"
          >
            KAYDET
          </button>
        </div>
      )}
    </div>
  );
};

export default Menuchain;
